import { CircularProgress } from "@mui/material";

export const FullScreenLoader = () => (
    <div
        style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999, // Optional: ensure it overlays
        }}
    >
        <CircularProgress />
    </div>
);
